export default __webpack_public_path__ + "static/disabled-dont-f63e87431dbfca7e4eed48505b6e93fa.png";